export const warehouseAND = "US, UK, AU, KR, and JP";
export const warehouseOR = "US, UK, AU, KR, or JP";


/** WEBPACK FOOTER **
 ** ./src/constants/warehouseCode.js
 **/